@import '@hevoio/hevo-ui-toolkit/styles/variables';

.userConsentWarning {
  backdrop-filter: blur(6px);
  position: absolute;
  display: flex;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  align-items: center;
  background: $surface-bg-80;
}

.userConsentWarningContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.helperText {
  margin: 0 $spacer * 9;
  font-weight: $font-weight-medium;
  color: $text-secondary;
  text-align: center;
}

.smallMargin {
  margin: 0 $spacer * 1.75;
}
